"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Practice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TierToJSON = exports.TierFromJSONTyped = exports.TierFromJSON = exports.instanceOfTier = void 0;
const runtime_1 = require("../runtime");
const OnTrackNotifications_1 = require("./OnTrackNotifications");
const OnTrackRules_1 = require("./OnTrackRules");
const ServiceFeeResponseType_1 = require("./ServiceFeeResponseType");
const StorageFile_1 = require("./StorageFile");
const TierContent_1 = require("./TierContent");
const TierPrice_1 = require("./TierPrice");
/**
 * Check if a given object implements the Tier interface.
 */
function instanceOfTier(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "content" in value;
    isInstance = isInstance && "isPopular" in value;
    isInstance = isInstance && "prices" in value;
    return isInstance;
}
exports.instanceOfTier = instanceOfTier;
function TierFromJSON(json) {
    return TierFromJSONTyped(json, false);
}
exports.TierFromJSON = TierFromJSON;
function TierFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'title': json['title'],
        'icon': !(0, runtime_1.exists)(json, 'icon') ? undefined : (0, StorageFile_1.StorageFileFromJSON)(json['icon']),
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'itemizations': !(0, runtime_1.exists)(json, 'itemizations') ? undefined : json['itemizations'],
        'content': (0, TierContent_1.TierContentFromJSON)(json['content']),
        'onTrackNotifications': !(0, runtime_1.exists)(json, 'onTrackNotifications') ? undefined : (0, OnTrackNotifications_1.OnTrackNotificationsFromJSON)(json['onTrackNotifications']),
        'onTrackRules': !(0, runtime_1.exists)(json, 'onTrackRules') ? undefined : (0, OnTrackRules_1.OnTrackRulesFromJSON)(json['onTrackRules']),
        'isPopular': json['isPopular'],
        'serviceFee': !(0, runtime_1.exists)(json, 'serviceFee') ? undefined : (0, ServiceFeeResponseType_1.ServiceFeeResponseTypeFromJSON)(json['serviceFee']),
        'prices': (json['prices'].map(TierPrice_1.TierPriceFromJSON)),
        'startingPriceTitle': !(0, runtime_1.exists)(json, 'startingPriceTitle') ? undefined : json['startingPriceTitle'],
    };
}
exports.TierFromJSONTyped = TierFromJSONTyped;
function TierToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'title': value.title,
        'icon': (0, StorageFile_1.StorageFileToJSON)(value.icon),
        'description': value.description,
        'itemizations': value.itemizations,
        'content': (0, TierContent_1.TierContentToJSON)(value.content),
        'onTrackNotifications': (0, OnTrackNotifications_1.OnTrackNotificationsToJSON)(value.onTrackNotifications),
        'onTrackRules': (0, OnTrackRules_1.OnTrackRulesToJSON)(value.onTrackRules),
        'isPopular': value.isPopular,
        'serviceFee': (0, ServiceFeeResponseType_1.ServiceFeeResponseTypeToJSON)(value.serviceFee),
        'prices': (value.prices.map(TierPrice_1.TierPriceToJSON)),
        'startingPriceTitle': value.startingPriceTitle,
    };
}
exports.TierToJSON = TierToJSON;
//# sourceMappingURL=Tier.js.map